import React from 'react'
import Heading from './Heading'
import './Skills.css'
import skills from './skills.json'

function Skills() {
  return (
    <div className='skills'>
      <Heading title='skills' />
      <div className='skills__row'>
        <div className='skills__column'>
          <h4>Languages</h4>
          {skills.map((skillColumn) =>
            skillColumn.languages.map((language) => <p>{language}</p>)
          )}
        </div>
        <div className='skills__column'>
          <h4>Frameworks</h4>
          {skills.map((skillColumn) =>
            skillColumn.frameworks.map((framework) => <p>{framework}</p>)
          )}
        </div>
        <div className='skills__column'>
          <h4>Tools</h4>
          {skills.map((skillColumn) =>
            skillColumn.tools.map((tool) => <p>{tool}</p>)
          )}
        </div>
        <div className='skills__column'>
          <h4>Design</h4>
          {skills.map((skillColumn) =>
            skillColumn.design.map((design) => <p>{design}</p>)
          )}
        </div>
      </div>
    </div>
  )
}

export default Skills
